export const DEVICE_FEATURE_KEY = 'device';
